// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".monthly-chart[data-v-0494214e] {\n  height: 330px;\n  padding: 18px 16px 14px;\n}\n.chart-frame[data-v-0494214e] {\n  position: relative;\n  height: 100%;\n}\n.monthly-chart[data-v-0494214e]  canvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n@media (max-width: 599px) {\n.monthly-chart[data-v-0494214e] {\n    height: 280px;\n    padding: 14px 10px 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
